import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ModalCloseButton from '../Modal/ModalCloseButton';

function ConfirmationModal({ title, text, confirmBtn, cancelBtn, confirmCallback, visible, closeCallback, data }) {

    return (
        <>
            <Modal show={visible} onHide={closeCallback}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                    <ModalCloseButton onClick={closeCallback} />
                </Modal.Header>
                <Modal.Body>{text}</Modal.Body>
                <Modal.Footer>
                    <Button variant="dark" onClick={closeCallback}>
                        {cancelBtn}
                    </Button>
                    <Button variant="secondary" onClick={() => { closeCallback(); confirmCallback(data) }}>
                        {confirmBtn}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ConfirmationModal;